import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProductsPage from './features/products/ProductsPage';
import DetailProductsPage from './features/details-product/DetailsProductPage';
import CartPage from './features/cart/CartPage';
import AuthPage from './features/auth/AuthPage';
import TransactionsPage from './features/transactions/TransactionsPage';
import ProfilePage from './features/profile/ProfilePage';
import HistoryTransactionsPage from './features/history-transactions/HistoryTransactionsPage';
import CategoryPage from './features/category/CategoryPage';
import SearchPage from './features/search/SearchPage';
import TypePageSection from './features/type/TypePageSection';

const App = () => {

  return (
    <Router>
      <Routes>
        <Route index path="/" element={<ProductsPage title="product" />} />
        <Route path="/detail-product" element={<DetailProductsPage title="detail product" />} />
        <Route path="/cart" element={<CartPage title="cart" />} />
        <Route path="/auth" element={<AuthPage title="auth" />} />
        <Route path="/transaction" element={<TransactionsPage title="transaction" />} />
        <Route path="/history-transaction" element={<HistoryTransactionsPage title="history transaction" />} />
        <Route path="/profile" element={<ProfilePage title="profile" />} />
        <Route path="/category/:param?" element={<CategoryPage title="category" />} />
        <Route path="/type-service/:param?" element={<TypePageSection title="type" />} />
        <Route path="/search/:param" element={<SearchPage title="search" />} />
      </Routes>
    </Router>
  );
};

export default App;
